// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"5b374d7b","213":"1da768e9","453":"b2a46831"}[chunkId] + ".chunk.js";
};